import qs from 'qs';

import { v1ApiClient } from '@/services';
import type { QueryParams, ResponseBody } from '@/shared/api/generated';
import { getCurrWorkspaceAlias } from '@/utils/workspace';

type GetNotificationsPath = '/v1/workspaces/{workspace_id}/notifications';

type GetNotificationsParams = QueryParams<GetNotificationsPath, 'get'>;
type GetNotificationsResponse = ResponseBody<GetNotificationsPath, 'get'>;

export const getNotifications = ({
  types,
}: GetNotificationsParams): Promise<GetNotificationsResponse> => {
  const wa = getCurrWorkspaceAlias();
  return v1ApiClient
    .get(`/workspaces/${wa}/notifications`, {
      params: { types },
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: 'repeat' }),
    })
    .then((res) => res.data);
};
